<template>
	<TeamingDropDown
		:class="classes"
		:disabled="disabled"
		:options="options"
		:value="value"
		v-on="bubble( 'change', 'opening', 'opened', 'closing', 'closed' )"
	/>
</template>

<script>
import EventsMixin from "../mixins/EventsMixin";
import { OneOnOneTeamRoleType } from "@teaming/common-enums";
import TeamingDropDown from "./TeamingDropDown";
export default {
	name: "OneOnOneRoleDropdown",
	emits: [ "change", "opening", "opened", "closing", "closed", ],
	mixins: [ EventsMixin, ],
	components: {
		TeamingDropDown,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			required: true,
		},
	},
	computed: {
		classes() {
			return `one-on-one-role-dropdown ${ this.className }`.trim();
		},
		/**
		 * Array.<Object.<text:String, value:String>>
		 */
		options() {
			const { $t, } = this;
			return [
				{
					text: $t( `common.OneOnOneRoleDropdown_${ OneOnOneTeamRoleType.MANAGER }Option` ),
					value: OneOnOneTeamRoleType.MANAGER,
				},
				{
					text: $t( `common.OneOnOneRoleDropdown_${ OneOnOneTeamRoleType.REPORT }Option` ),
					value: OneOnOneTeamRoleType.REPORT,
				},
				{
					text: $t( `common.OneOnOneRoleDropdown_${ OneOnOneTeamRoleType.PEER }Option` ),
					value: OneOnOneTeamRoleType.PEER,
				},
			];
		},
	},
};
</script>
